<script>
const axios = require('axios')
const aws4 = require('aws4');

export default { 
  props: ['owner'],
  created: function(){
    
  }, 
  data: function(){
    return{
      stageName: process.env.STAGE_NAME , // '/Stage/', 
      host: process.env.HOST
    }
  },
  methods: {  
    call: async function (endpoint, data, successHandler, errorHandler, method, contentType, headers) {
      var self = this;
      
      let dt = new Date()
      let expDt = new Date(self.owner.timer);

      var currCreds = JSON.stringify(self.owner.creds);

      function waitFor(conditionFunction) {
       
        const poll = resolve => {
          console.log('poll')
          if(conditionFunction()) resolve();
          else setTimeout(() => poll(resolve), 200);
        }
        return new Promise(poll);
      }
     
      if(dt.getTime() > expDt.getTime()){
        if(self.owner.isAuth){
          self.owner.showModalFullSpinner()
          await self.owner.azCognito.refreshSession()
          await waitFor(() => {
            return currCreds != JSON.stringify(self.owner.creds)
          });
          self.owner.hideModalFullSpinner()
        }
      }
     
      self.owner.startTimer()

      var path = endpoint 

      //TODO: For Dev only, remove for prod
      if(contentType == 'static'){
        path = "/static/" + endpoint;
      }

  
      var signedRequest = {}
      if(contentType != 'static'){
        let request = {
            host:  process.env.API_HOST  ,//process.env.API_HOST, //'a4mbz38fe7.execute-api.us-east-1.amazonaws.com', //this.host,
            method: method.toUpperCase(),
            path: `${this.stageName}${path}`,
            url: `https://${this.host}/${path}`,
            //withCredentials: true,
            //headers: {'Access-Control-Allow-Origin' : '*'}
        }



        if(method == "POST" || method == 'PUT'){
            request.body = JSON.stringify(data);
            request.data = data;
            //request.headers = {'Access-Control-Allow-Origin' : '*', 'Content-Type' : 'Application/json'};
            request.headers = {'Content-Type' : 'Application/json'};
        }

        if(headers){
            if (!request.headers) {
              request.headers = {};
            }
            for (var i in headers){ 
              request.headers[i] = headers[i];
            }
        }

  

        signedRequest = aws4.sign(request, self.owner.creds) //sessionStorage.getItem('creds')

        delete signedRequest.headers['Content-Length']
        delete signedRequest.headers['Host']
          
      } else {
           signedRequest = {
              method: method,
              url: path,
              data: ''
          }
      }

      axios(
        signedRequest
        )
        .then(function (response) {
          var data = response.data;
          var status = response.status;
          var statusText = response.statusText;
          var headers = response.headers
          var config = response.config;
          successHandler(data, status, statusText, headers, config)
        })
        .catch(function (error) {
          var data, status, headers, errorRequest
          if(error.response){
             data = error.response.data;
             status = error.response.status ;
             headers = error.response.headers;
          } else if(error.request){
            errorRequest = error.request;
          }
          var config = error.config;
          var msg = error.message;
          errorHandler(data, status, headers, config, msg, errorRequest)
        });
    },
    get: function (path, data, successHandler, errorHandler, contentType, headers) {
      this.call(path, data, successHandler, errorHandler, "GET", contentType, headers);
    },

    post: function (path, data, successHandler, errorHandler, contentType, headers) {
      this.call(path, data, successHandler, errorHandler, "POST", contentType, headers);
    },

    delete: function (path, data, successHandler, errorHandler, contentType, headers) {
      this.call(path, data, successHandler, errorHandler, "DELETE", contentType, headers);
    },

    put: function (path, data, successHandler, errorHandler, contentType, headers) {
      this.call(path, data, successHandler, errorHandler, "PUT", contentType, headers);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/APIclient.vue